<script>
import countryRegionData from 'country-region-data';
import get from 'lodash/get';
import find from 'lodash/find';
import each from 'lodash/each';
import isEqual from 'lodash/isEqual';
import vueMixins from 'viralstyle-ui/src/vueMixins';
import VsButton from 'viralstyle-ui/src/VsButton';
import VsInput from 'viralstyle-ui/src/VsInput';
import VsSelect from 'viralstyle-ui/src/VsSelect';
import { mapState } from 'vuex';

import { paymentCheckValidator } from '../_settings-validator';

export default {
  components: {
    VsInput,
    VsButton,
    VsSelect,
  },
  mixins: [vueMixins],
  props: {
    hideSubmit: [Boolean, String],
  },
  data: () => ({
    paymentCheckValidator,
  }),
  computed: {
    ...mapState({
      processing: state => state.processing,
      paymentInfo: state => state.settings.paymentInfo,
      paymentInfoSubmitted: state => state.settings.paymentInfoSubmitted,
      originalPaymentInfo: state => state.settings.originalPaymentInfo,
    }),
    usRegions() {
      return find(countryRegionData, country => country.countryShortCode === 'US').regions;
    },
    regions() {
      let regions = {};

      each(this.usRegions, region => regions[region.name] = region.name);

      return regions;
    },
    selectedState() {
      let state = this.get(this.paymentInfo, 'bank_check_details.state');

      if (state && state.length === 2) {
        each(this.usRegions, regionObject => {
          if (regionObject.shortCode === state) {
            state = regionObject.name;

            this.$store.commit('updateState', {
              object: this.paymentInfo.bank_check_details,
              property: 'state',
              value: state,
            });

            return false;
          }
        });
      }

      return state;
    },
  },
  created() {
    paymentCheckValidator.clear();
    if (this.originalPaymentInfo && !isEqual(this.paymentInfo.bank_check_details, this.originalPaymentInfo.bank_check_details)) {
      this.$store.commit('updateStateClone', { object: this.paymentInfo, property: 'bank_check_details', value: this.originalPaymentInfo.bank_check_details });
    }
  },
  updated() {
    this.$emit('update');
  },
  methods: {
    updatePaymentInfo(e, prop) {
      let value = get(e, 'target.value') !== undefined ? get(e, 'target.value') : e;
      this.$store.commit('updatePaymentInfo', { prop: `bank_check_details.${prop}`, value });
      paymentCheckValidator.validate(prop, value);
    },
    async savePaymentMethod() {
      let valid = await paymentCheckValidator.validateAll(this.paymentInfo.bank_check_details);
      if (valid) {
        this.$store.dispatch('savePaymentMethod', 'BANK_CHECK');
        this.$store.commit('updateState', { object: this.paymentInfoSubmitted, property: 'BANK', value: false });
      } else {
        this.$store.commit('updateState', { object: this.paymentInfoSubmitted, property: 'BANK', value: true });
      }
    },
  },
};
</script>

<template lang='pug'>
.accordion-content__client
  vs-input(type='text', full-width, placeholder='Full Name', :value='get(paymentInfo, "bank_check_details.name")',
    prevent-autofill,
    @input='updatePaymentInfo($event, "name")',
    :error='paymentInfoSubmitted.BANK && paymentCheckValidator.hasError("name")')
  .vs-error(v-show='paymentInfoSubmitted.BANK && paymentCheckValidator.hasError("name")')
    | {{paymentCheckValidator.firstError('name')}}
  .payouts-settings__address
    vs-input(type='text', full-width, placeholder='Address', :value='get(paymentInfo, "bank_check_details.address")',
      prevent-autofill,
      @input='updatePaymentInfo($event, "address")',
      :error='paymentInfoSubmitted.BANK && paymentCheckValidator.hasError("address")')
    .vs-error(v-show='paymentInfoSubmitted.BANK && paymentCheckValidator.hasError("address")')
      | {{paymentCheckValidator.firstError('address')}}
  .payouts-settings__apt
    vs-input(type='text', full-width, placeholder='Apt', :value='get(paymentInfo, "bank_check_details.apt")',
      prevent-autofill,
      @input='updatePaymentInfo($event, "apt")',
      :error='paymentInfoSubmitted.BANK && paymentCheckValidator.hasError("apt")')
    .vs-error(v-show='paymentInfoSubmitted.BANK && paymentCheckValidator.hasError("apt")')
      | {{paymentCheckValidator.firstError('apt')}}
  vs-input(type='text', full-width, placeholder='City', :value='get(paymentInfo, "bank_check_details.city")',
    prevent-autofill,
    @input='updatePaymentInfo($event, "city")',
    :error='paymentInfoSubmitted.BANK && paymentCheckValidator.hasError("city")')
  .vs-error(v-show='paymentInfoSubmitted.BANK && paymentCheckValidator.hasError("city")')
    | {{paymentCheckValidator.firstError('city')}}
  .payouts-settings__address
    vs-select(
      v-if='Object.keys(regions).length',
      key-value,
      prevent-autofill,
      placeholder='State',
      :value='selectedState',
      :options='regions',
      :error='paymentInfoSubmitted.BANK && paymentCheckValidator.hasError("state")',
      @input='updatePaymentInfo($event, "state")',
    )
    .vs-error(v-show='paymentInfoSubmitted.BANK && paymentCheckValidator.hasError("state")')
      | {{paymentCheckValidator.firstError('state')}}
  .payouts-settings__apt
    vs-input(type='text', full-width, placeholder='Zip', :value='get(paymentInfo, "bank_check_details.pin_code")',
      prevent-autofill,
      @input='updatePaymentInfo($event, "pin_code")',
      :error='paymentInfoSubmitted.BANK && paymentCheckValidator.hasError("pin_code")')
    .vs-error(v-show='paymentInfoSubmitted.BANK && paymentCheckValidator.hasError("pin_code")')
      | {{paymentCheckValidator.firstError('pin_code')}}
  vs-input(type='text', full-width, placeholder='Phone Number', :value='get(paymentInfo, "bank_check_details.mobile")',
    prevent-autofill,
    @input='updatePaymentInfo($event, "mobile")',
    :error='paymentInfoSubmitted.BANK && paymentCheckValidator.hasError("mobile")')
  .vs-error(v-show='paymentInfoSubmitted.BANK && paymentCheckValidator.hasError("mobile")')
    | {{paymentCheckValidator.firstError('mobile')}}
  vs-button(v-if='!hideSubmit', text='save', icon='content-save', :processing='processing',
    :disabled='processing', @click='savePaymentMethod')
</template>